import { render } from "./SpacerRow.vue?vue&type=template&id=4b382b5c"
import script from "./SpacerRow.vue?vue&type=script&lang=js"
export * from "./SpacerRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__